
export interface DashboardModuleSharedWidgetsNewCaseWidgetItem {
    subType: string
    disabled: boolean
    icon: string
    label: string
}

export interface DashboardModuleSharedWidgetsNewCaseWidgetPaginatorInfo {
    size: number
    id: string
    identifierType: string
}

export interface DashboardModuleSharedWidgetsNewCaseWidgetService {
    paginator(info: DashboardModuleSharedWidgetsNewCaseWidgetPaginatorInfo): any
}

export interface DashboardModuleSharedWidgetsNewCaseWidgetState {
    search: string
}
export const initialDashboardModuleSharedWidgetsNewCaseWidgetState =
    (): DashboardModuleSharedWidgetsNewCaseWidgetState => ({
        search: ''
    })
